<script lang="ts">
	import type { Snippet } from 'svelte';
	import Line from '$lib/components/search/autocomplete/Line.svelte';
	import { highlight } from '$lib/services/store/searchHistory';

	interface Props {
		label: string;
		additionalLabel: string | undefined;
		active?: boolean;
		id: string;
		testid?: string;
		highlighted?: string;
		isVisible?: boolean;
		lineItem?: Snippet<[any]>;
		onclick?: () => void;
		onmouseover?: () => void;
		onfocus?: () => void;
		onSelectItem?: () => void;
	}

	const {
		label,
		additionalLabel,
		active = false,
		id,
		highlighted = '',
		isVisible = false,
		onclick,
		onmouseover,
		onfocus,
		onSelectItem,
		lineItem,
		testid = 'result',
	}: Props = $props();

	const { highlightText, beforeText, afterText } = $derived(highlight(label, highlighted));
</script>

<li
	class={['relative cursor-pointer overflow-hidden text-ellipsis flex-shrink-0 whitespace-nowrap flex flex-row gap-x-2 last:pb-1 rd-1', active && ['active', 'bg-base-15']]}
	role="option"
	aria-selected={active}
	aria-hidden={isVisible}
	data-testid={`${testid}-item-${id}`}
	{onmouseover}
	{onfocus}
	{onclick}
>
	{#if lineItem}
		{@render lineItem({ beforeText, afterText, highlightText, additionalLabel, onSelectItem })}
	{:else}
		<Line {beforeText} {afterText} {highlightText} {additionalLabel} {onSelectItem} />
	{/if}
</li>
